import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@material-ui/core'

import * as R from 'ramda'
import React, { FC, useEffect } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'

import Loading from '../../components/loading'
import { ProductFormInterface } from '../../interfaces/product'
import { getProductDetailRequest } from '../../redux/product/actions'
import {
  getIsCreateOrUpdatingProduct,
  getIsFetchingProductDetail,
  getProductDetail
} from '../../redux/product/selectors'
import CompanyProductFormMainBody from './CompanyProductFormMainBody'

const DialogFormLoadingContainer = styled.div`
  width: 500px;
  height: 800px;
`

type Props = {
  productId: string
  updateProductHandler: (updatedProduct: ProductFormInterface) => void
  handleCloseDialog: () => void
}

const CompanyProductDetailForm: FC<Record<string, unknown> & Props> = ({
  productId,
  updateProductHandler,
  handleCloseDialog
}: Props) => {
  const dispatch = useDispatch()
  const emptyProduct = {
    categoryId: '',
    name: '',
    hsCode: '',
    brands: '',
    packaging: '',
    category: {
      name: ''
    },
    seasonsAvailable: []
  }
  const productDetail = R.pick(
    [
      'categoryId',
      'name',
      'hsCode',
      'seasonsAvailable',
      'brands',
      'packaging',
      'category'
    ],
    (useSelector(getProductDetail) as ProductFormInterface) ?? emptyProduct
  )

  const methods = useForm<ProductFormInterface>({
    defaultValues: productDetail
  })

  const isFetchingProductDetail = useSelector(getIsFetchingProductDetail)
  const isUpdatingProductDetail = useSelector(getIsCreateOrUpdatingProduct)

  const { handleSubmit, setValue } = methods

  useEffect(() => {
    dispatch(getProductDetailRequest(productId))
  }, [productId])

  // use to setValue to the form fields once the detail is obtained, odd reason
  useEffect(() => {
    if (R.not(R.equals(productDetail, emptyProduct))) {
      setValue('categoryId', R.prop('categoryId', productDetail))
      setValue('name', R.prop('name', productDetail))
      setValue('hsCode', R.prop('hsCode', productDetail))
      setValue('brands', R.prop('brands', productDetail))
      setValue('packaging', R.prop('packaging', productDetail))
      setValue('seasonsAvailable', R.prop('seasonsAvailable', productDetail))
    }
  }, [productDetail])

  return (
    <FormProvider {...methods}>
      <form>
        {isFetchingProductDetail || isUpdatingProductDetail ? (
          <DialogFormLoadingContainer>
            <Loading />
          </DialogFormLoadingContainer>
        ) : (
          <>
            <DialogTitle id="form-dialog-title">Product</DialogTitle>
            <DialogContent>
              <CompanyProductFormMainBody productDetail={productDetail} />
            </DialogContent>
            <DialogActions>
              <Button
                variant="outlined"
                onClick={handleCloseDialog}
                color="default"
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={handleSubmit(updateProductHandler)}
                color="primary"
              >
                Update
              </Button>
            </DialogActions>
          </>
        )}
      </form>
    </FormProvider>
  )
}

export default CompanyProductDetailForm
